export default __webpack_public_path__ + "static/media/Boo-Invited-Welcome.596a764b.png";